import { WidgetDefinition } from "./common";
import WidgetType from "../enum/WidgetType";

const Rectangle: WidgetDefinition = {

    type: WidgetType.RECTANGLE,
    className: 'widget-rectangle',

    settingsSectionComponents: [
        'dmb-section-widget-style',
        'dmb-section-widget-animation'
    ],

    defaultSize: {
        size: 0.1,
        ratio: 1
    },

    defaultStyle: {
        backgroundColor: 'FF0000',
        // borderSize: 1,
        // borderColor: 'FFFFFF',
        opacity: 100
    }
}

export default Rectangle